import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    list(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/locations/${id}/containersvaware/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    get(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/containers/" + id + "/"
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    report(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/containers/" + id + "/report/",
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
